import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { createUseStyles } from 'react-jss'
import { useNavigate } from 'react-router-dom'

const useStyles = createUseStyles({
  navButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
})

export default function NavigationButtons({ nextPath = null, prevPath = null }) {
  const navigate = useNavigate()
  const classes = useStyles()
  const navigateTo = useCallback(
    path => path && navigate(path, { replace: true }),
    [navigate],
  )

  return (
    <div className={classes.navButtons}>
      <Button
        icon={<LeftOutlined />}
        disabled={!prevPath}
        onClick={() => navigateTo(prevPath)}
      >
        Previous
      </Button>

      <Button
        icon={<RightOutlined />}
        disabled={!nextPath}
        onClick={() => navigateTo(nextPath)}
      >
        Next
      </Button>
    </div>
  )
}

NavigationButtons.propTypes = {
  nextPath: PropTypes.string,
  prevPath: PropTypes.string,
}
